import React from "react"
import { SafeAreaView, StatusBar } from "react-native"
import { cn } from "../../styles/utils"
import { DesktopOnly } from "../DesktopOnly"
import { MobileOnly } from "../MobileOnly"
import { DesktopLayout } from "./DesktopLayout"
import { MobileLayout } from "./MobileLayout"

type BaseScreenProps = {
  children: React.ReactNode
  className?: string
  statusBarStyle?: "default" | "dark-content" | "light-content"
  backgroundColor?: string
}

export const BaseScreen: React.FC<BaseScreenProps> = ({
  children,
  className,
  statusBarStyle = "dark-content",
  backgroundColor = "rgb(var(--color-background-0))",
}) => {
  return (
    <SafeAreaView className={cn("flex-1 bg-background-0", className)}>
      <StatusBar barStyle={statusBarStyle} backgroundColor={backgroundColor} />

      <MobileOnly>
        <MobileLayout>{children}</MobileLayout>
      </MobileOnly>

      <DesktopOnly>
        <DesktopLayout>{children}</DesktopLayout>
      </DesktopOnly>
    </SafeAreaView>
  )
}
